interface ErrorPageProps {
  status?: number;
  title?: string;
  message?: string;
}

export function ErrorPage({
  status = 500,
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again later.',
}: ErrorPageProps) {
  return (
    <div className="text-center">
      <div className="mb-8">
        <div className="text-8xl font-bold text-gray-200 mb-4">{status}</div>
        <h1 className="text-3xl font-semibold text-gray-900 mb-4">{title}</h1>
        <p className="text-lg text-gray-600 mb-8">{message}</p>
      </div>
    </div>
  );
}
